/**
 *
 * BluDeltaLogo
 *
 */

import * as React from 'react';
import logo from './logo-symbol-with-word-mark.png';
import { NavLink } from 'react-router-dom';

interface BluDeltaLogoProps {
  to: string;
}

export const BluDeltaLogo: React.FC<BluDeltaLogoProps> = ({ to }) => (
  <NavLink to={to}>
    <img src={logo} alt="logo" style={{height: '66px', padding: '20px 0 10px 0'}}  />
  </NavLink>
);
